import { PageNotFound } from '@shared/components';
import { useNavigate } from '@user-management/router';

export default function NotFoundPage() {
  const navigate = useNavigate();

  const handleBackToHome = () => {
    navigate('/');
  };

  return <PageNotFound fullscreen onBackToHome={handleBackToHome} />;
}
